import { DoctorInfoEntity } from "@/domain/entity/admin/doctor-info-entity";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchDoctorListUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(): Promise<SATResult<DoctorInfoEntity[], SATError>> {
    const result = await this.adminRepository.fetchDoctorList();

    if (result.isSuccess) {
      console.log("[FetchDoctorListUsecase] :: execute :: 의사 목록 조회 성공", result.value);
      return SATResult.success(result.value);
    }

    console.log("[FetchDoctorListUsecase] :: execute :: 의사 목록 조회 실패", result.error);
    return SATResult.failure(result.error);
  }
}
